import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { B02aCompanyAddPage } from '../b02a-company-add/b02a-company-add';
import { B02bCompanyInfoPage } from '../b02b-company-info/b02b-company-info';
import { B02cUserListPage } from '../b02c-user-list/b02c-user-list';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02UserManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
  ADDR1: string; 
  ADDR2: string; 
  ADDR3: string; 
  CONTACT_NO: string;                      
  EMAIL: string; 
  PIC: string;  
  BRANCH_ACTIVE: string;  
}

@IonicPage()
@Component({
  selector: 'page-b02-user-management',
  templateUrl: 'b02-user-management.html',
})
export class B02UserManagementPage {

  loading: any;
  Status: any;
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  public errorMessage: any = "";
  GRP_ID: any;
  BRANCH_ID: any;
  searchdata:any;
  searchMessage:any ="";
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, private toastCtrl: ToastController, 
              public loadingCtrl: LoadingController) {

    this.BRANCH_ID = sessionStorage.getItem('userbranchid');
    this.GRP_ID = sessionStorage.getItem('usergroupid');
    
    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];

    if(this.GRP_ID=="1") {            //system admin
      temp_tbl = ["All"];
      temp_column = ["All"];
      temp_value = ["All"];
    }
    else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //branch admin/ manager
      temp_tbl = ["BRANCH"]; 
      temp_column = ["BRANCH_ID"];
      temp_value = [this.BRANCH_ID];
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02UserManagementPage');
  }

  goToAddUser(){
    this.navCtrl.push(B02aCompanyAddPage);
  }

  editUser(ID){
    this.navCtrl.push(B02bCompanyInfoPage, {paramID: ID});
  }

  viewUser(ID){
    this.navCtrl.push(B02cUserListPage, {paramID: ID});       
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  clearItem(){
    this.searchdata = "";
   
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.branchItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.searchdata!=""){
      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
      this.searchdata="";
    }
    else {

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let searchitem = this.serviceapi.search(this.searchdata,"All","All")
    console.log(jsonitem);
    let mydata = Object.assign(jsonitem,searchitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.branchArr = Records;
          this.branchItems = this.branchArr;
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02-user-management/b02-user-management.ts